import type { ISODateTime } from "@inrev/common";
import { DateTime } from "luxon";
import { type FC, useId } from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { Icon } from "../../primitives";

type PeriodReviewedIndicatorProps = {
	reviewDate: ISODateTime;
	tooltipId?: string;
};

export const PeriodReviewedIndicator: FC<PeriodReviewedIndicatorProps> = ({
	reviewDate,
	tooltipId,
}) => {
	const generatedId = useId();
	const id = tooltipId ?? generatedId;

	return (
		<>
			<span
				data-testid="period-reviewed-indicator"
				data-tooltip-id={id}
				data-tooltip-content={`Reviewed on ${DateTime.fromISO(reviewDate).toFormat("MM/dd/yyyy")}`}
				className="mr-0.5"
			>
				<Icon type="check" size="micro" color="confirm" />
			</span>
			<ReactTooltip id={id} style={{ zIndex: 9999 }} />
		</>
	);
};
